export function formatarDocumento(valor) {
  if (!valor) return "";
  const doc = valor.toString().replace(/\D/g, "");
  if (doc.length === 11) {
    // CPF
    return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
  // Não é CPF, retorna o valor original (passaporte ou outro)
  return valor;
}

export function formatarCEP(cep) {
  if (!cep) return "";
  cep = cep.toString().replace(/\D/g, "");
  return cep.replace(/(\d{5})(\d{3})/, "$1-$2");
}
